import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { toast } from "react-hot-toast";

type RequestType = {
  contaReceberId: number;
};

export const useGetVisualizacaoContaReceber = (request: RequestType) => {
  const onError = () => {
    toast.error("Erro ao buscar conta a receber");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroAcordoDTO>>({
    key: ["visualizar-conta-receber-processo-judicial", request.contaReceberId],
    url: api.contaReceber.getVisualizacaoContaReceber,
    pathVariables: request.contaReceberId?.toString(),
    enabled: request.contaReceberId !== undefined,
    onError,
    config,
  });
};
